import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4c8b6d3d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=4c8b6d3d&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=4c8b6d3d&prod&scoped=true&lang=css"
import style2 from "./App.vue?vue&type=style&index=2&id=4c8b6d3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b6d3d",
  null
  
)

export default component.exports